import React, { Component } from "react";

class VoteButton extends Component {
  render() {
    return (
      <button
        type="button"
        className={this.props.className}
        onClick={this.props.toggleClassName}
      >
        { this.props.children }
        <i className={this.props.active ? "fa fa-check" : "fa fa-heart"} />
      </button>
    );
  }
};

export default VoteButton;
